import { ItemAttributeOption } from "@/models/HomePageSearchResponse";
import { Autocomplete, TextField } from "@mui/material";

export default function AspectAutocomplete({
  label,
  value,
  onChange,
  options,
  inputRef,
  error,
  helperText,
  required,
  groupBy,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: ItemAttributeOption[];
  inputRef?: React.Ref<HTMLInputElement>;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  groupBy?: (option: ItemAttributeOption) => string;
}) {
  return (
    <Autocomplete
      disablePortal
      options={options}
      value={options.find((option) => option.value === value) || null}
      onChange={(_, newValue) => {
        onChange(newValue?.value ?? "");
      }}
      groupBy={groupBy}
      renderInput={(params) => (
        <TextField
          {...params}
          ref={inputRef}
          label={label}
          error={error}
          helperText={helperText}
          required={required}
        />
      )}
    />
  );
}
